import DialogStackContext from './DialogStackContext'
import { useContext } from 'react'

export default function useCrmDialogs() {
  return useContext(DialogStackContext)
}
